import { Button } from "react-admin"

export const ViewFileButton = (props) => {
    return <Button onClick={() => { window.open(props.record.path) }} label={'Visualizar'} />
}